module.exports = __webpack_public_path__ + "img/laodongfengxianguanli.c04663c8.png";